import { render } from "./BaseBooleanFilterButton.vue?vue&type=template&id=64f5ff81"
import script from "./BaseBooleanFilterButton.vue?vue&type=script&lang=js"
export * from "./BaseBooleanFilterButton.vue?vue&type=script&lang=js"

import exportComponent from "/browser/CARTaGENE_vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__